export { default } from './clamp';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/clamp/index.js
// module id = 230
// module chunks = 25